<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />

        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-12">
                <section class="section section-lg pt-lg-0 mt--200">
                  <div class="container">
                    <div class="row justify-content-center">
                      <div class="col-lg-12">
                        <div class="row justify-content-center">
                          <base-button
                            class="mb-2 mr-sm-2 mb-sm-0"
                            v-on:click="getStartLocation = true"
                            type="info"
                            v-if="source !== '' && !getStartLocation"
                          >
                            <span>From: {{ source }}</span>
                          </base-button>

                          <base-button
                            class="mb-2 mr-sm-2 mb-sm-0"
                            v-on:click="getDestinationLocation = true"
                            type="info"
                            v-if="destination !== '' && !getDestinationLocation"
                          >
                            <span>To: {{ destination }}</span>
                          </base-button>

                          <base-button
                            class="mb-2 mr-sm-2 mb-sm-0"
                            v-on:click="getStartDate = true"
                            type="info"
                            v-if="dates.start !== '' && !getStartDate"
                          >
                            <span>Start Date: {{ dates.start }}</span>
                          </base-button>

                          <base-button
                            class="mb-2 mr-sm-2 mb-sm-0"
                            v-on:click="getEndDate = true"
                            type="info"
                            v-if="dates.end !== '' && !getEndDate"
                          >
                            <span>End Date: {{ dates.end }}</span>
                          </base-button>
                        </div>
                        <div class="row row-grid">
                          <div class="col-lg-12">
                            <div id="iwt1">
                              <div class="cell" id="i91a">
                                <div id="ijsk">
                                  <div id="example-1">
                                    <transition name="slide-fade">
                                      <div v-if="getDestinationLocation">
                                        <h3 class="text-center text-white">
                                          Where are you going to?
                                        </h3>
                                        <autocomplete
                                          :search="searchLocation"
                                          placeholder="Destination..."
                                          aria-label="Destination..."
                                          :debounce-time="500"
                                          @submit="onGettingDestinationLocation"
                                        >
                                          <!-- <template #result="{ result, props }">
                                            <li
                                              v-bind="props"
                                              class="autocomplete-result location-results-item"
                                              :style="{
                                                backgroundImage:
                                                  'url(' +
                                                  require('@/assets/img/location.svg') +
                                                  ')',
                                              }"
                                            >
                                              <div
                                                class="location-results"
                                                v-html="result"
                                              />
                                            </li>
                                          </template> -->
                                        </autocomplete>
                                      </div>
                                    </transition>
                                  </div>
                                  <div id="example-1">
                                    <transition name="slide-fade">
                                      <div v-if="getStartLocation">
                                        <h3 class="text-center text-white">
                                          Where are you starting from?
                                        </h3>
                                        <autocomplete
                                          :search="searchLocation"
                                          placeholder="Source..."
                                          aria-label="Source..."
                                          :debounce-time="500"
                                          @submit="onGettingSourceLocation"
                                        >
                                          <!-- <template #result="{ result, props }">
                                            <li
                                              v-bind="props"
                                              class="autocomplete-result location-results-item"
                                              :style="{
                                                backgroundImage:
                                                  'url(' +
                                                  require('@/assets/img/location.svg') +
                                                  ')',
                                              }"
                                            >
                                              <div
                                                class="location-results"
                                                v-html="result"
                                              />
                                            </li>
                                          </template> -->
                                        </autocomplete>
                                      </div>
                                    </transition>
                                  </div>

                                  <div id="example-1">
                                    <transition name="slide-fade">
                                      <div v-if="getStartDate">
                                        <h3 class="text-center text-white">
                                          When are you starting?
                                          <small class="text-muted"
                                            >Time to enjoy!
                                          </small>
                                        </h3>
                                        <base-input
                                          addon-left-icon="ni ni-calendar-grid-58"
                                        >
                                          <flat-picker
                                            slot-scope="{ focus, blur }"
                                            @on-open="focus"
                                            @on-close="blur"
                                            @on-change="onGettingStartDate"
                                            :config="{
                                              allowInput: false,
                                            }"
                                            class="form-control datepicker"
                                            v-model="dates.start"
                                          >
                                          </flat-picker>
                                        </base-input>
                                      </div>
                                    </transition>
                                  </div>

                                  <div id="example-2">
                                    <transition name="slide-fade">
                                      <div v-if="getEndDate">
                                        <h3 class="text-center text-white">
                                          When are you coming back?
                                          <small class="text-muted"
                                            >Home sweet home!
                                          </small>
                                        </h3>
                                        <base-input
                                          addon-left-icon="ni ni-calendar-grid-58"
                                        >
                                          <flat-picker
                                            slot-scope="{ focus, blur }"
                                            @on-open="focus"
                                            @on-close="blur"
                                            @on-change="onGettingEndDate"
                                            :config="{
                                              allowInput: false,
                                            }"
                                            class="form-control datepicker"
                                            v-model="dates.end"
                                          >
                                          </flat-picker>
                                        </base-input>
                                      </div>
                                    </transition>
                                  </div>

                                  <div id="example-1">
                                    <transition name="slide-fade">
                                      <div v-if="getTravelMode">
                                        <h3 class="text-center text-white">
                                          What's your means of reaching the
                                          destination?
                                          <small class="text-muted"
                                            >Happy Travelling!
                                          </small>
                                        </h3>

                                        <div class="row justify-content-center">
                                          <b-form-radio-group
                                            class="mb-2 mr-sm-2 mb-sm-0"
                                            id="btn-radios-2"
                                            v-model="travelMode"
                                            :options="options"
                                            @change="onGettingTravelMode"
                                            buttons
                                            size="lg"
                                            name="radio-btn-outline"
                                          ></b-form-radio-group>
                                        </div>

                                        <div class="row justify-content-center">
                                          <base-button
                                            type="default"
                                            v-if="showSubmit"
                                            icon="ni ni-user-run"
                                            v-on:click="onSubmit"
                                            >I'm all good, Create
                                            Vacation!</base-button
                                          >
                                        </div>
                                      </div>
                                    </transition>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <section class="section section-lg pt-lg-0 mt--200">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <div class="text-center" v-if="invitation.length > 0">
                <b-button variant="info">
                  Invitations
                  <b-badge variant="secondary">{{ invitation.length }}</b-badge>
                </b-button>
              </div>

              <div class="row row-grid">
                <div
                  class="col-lg-4 list-item"
                  v-for="v in invitation"
                  :key="v.id"
                >
                  <div class="mt-3">
                    <b-card-group deck>
                      <b-card
                        border-variant="info"
                        header-bg-variant="info"
                        header-text-variant="white"
                        align="center"
                        :header="v.vacation.dest_loc"
                      >
                        <b-list-group flush>
                          <b-list-group-item
                            >ID: {{ v.vacation.id }}</b-list-group-item
                          >
                          <b-list-group-item
                            >From: {{ v.vacation.start_loc }}</b-list-group-item
                          >
                          <b-list-group-item
                            >Start:
                            {{ v.vacation.start_date }}</b-list-group-item
                          >
                          <b-list-group-item
                            >End : {{ v.vacation.end_date }}</b-list-group-item
                          >
                        </b-list-group>

                        <b-card-footer>
                          <b-button
                            @click="
                              $router.push({
                                name: 'vacation',
                                params: {
                                  id: v.vacation.id,
                                  destination: v.vacation.dest_loc,
                                  startDate: v.vacation.start_date,
                                  endDate: v.vacation.end_date,
                                  confirmStatus: false,
                                },
                              })
                            "
                            variant="outline-info"
                            >View</b-button
                          >
                        </b-card-footer>
                      </b-card>
                    </b-card-group>
                  </div>
                </div>
              </div>

              <div class="text-center">
                <b-button variant="primary">
                  Your Vacations
                  <b-badge variant="secondary">{{
                    participant && participant.length
                  }}</b-badge>
                </b-button>
              </div>
              <div class="row row-grid">
                <div
                  class="col-lg-4 list-item"
                  v-for="p in participant"
                  :key="p.vacation.id"
                >
                  <div class="mt-3">
                    <b-card-group deck>
                      <b-card
                        border-variant="primary"
                        header-bg-variant="primary"
                        header-text-variant="white"
                        align="center"
                        :header="p.vacation.dest_loc"
                      >
                        <b-list-group flush>
                          <b-list-group-item
                            >ID: {{ p.vacation.id }}</b-list-group-item
                          >
                          <b-list-group-item
                            >From: {{ p.vacation.start_loc }}</b-list-group-item
                          >
                          <b-list-group-item
                            >Start:
                            {{ p.vacation.start_date }}</b-list-group-item
                          >
                          <b-list-group-item
                            >End : {{ p.vacation.end_date }}</b-list-group-item
                          >
                        </b-list-group>

                        <b-card-footer>
                          <b-button
                            @click="
                              $router.push({
                                name: 'vacation',
                                params: {
                                  id: p.vacation.id,
                                  destination: p.vacation.dest_loc,
                                  startDate: p.vacation.start_date,
                                  endDate: p.vacation.end_date,
                                  confirmStatus: true,
                                },
                              })
                            "
                            variant="primary"
                            >Go</b-button
                          >
                        </b-card-footer>
                      </b-card>
                    </b-card-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <modal
      :show.sync="showModal"
      gradient="primary"
      modal-classes="modal-primary modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Your vacation is ready!
      </h6>

      <div class="py-3 text-center">
        <i class="ni ni-bell-55 ni-3x"></i>
        <h4 class="heading mt-4">Congratulations!</h4>
        <p>
          You can go and add more details or share this with your friends to
          update this vacation colaboratively!
        </p>
      </div>

      <template slot="footer">
        <base-button type="white">Add Details</base-button>
        <!-- 
        <base-button type="link" text-color="white">Share</base-button>
        -->
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="showModal = false"
        >
          Close
        </base-button>
      </template>
    </modal>
  </div>
</template>

<script>
import styles from "../assets/css/Landing.css";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Modal from "@/components/Modal.vue";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import {
  ALL_VACATIONS,
  MY_VACATIONS,
  ADD_VACATION,
  ADD_PARTICIPANT,
  GET_INVITATIONS,
} from "../graphql/graphql";

export default {
  components: { flatPicker, Modal, Autocomplete },
  data() {
    return {
      getDestinationLocation: true,
      getStartLocation: false,
      getStartDate: false,
      getEndDate: false,
      getTravelMode: false,
      showSubmit: false,
      travelMode: "",
      source: "",
      destination: "",
      showModal: false,
      value: ["apple", "orange", "banana"],
      dates: {
        start: "",
        end: "",
      },
      options: [
        { text: "Flight", value: "flight" },
        { text: "Car", value: "car" },
        { text: "Train", value: "train" },
        { text: "Bus", value: "bus" },
      ],
      vacation: [],
      invitation: [],
    };
  },
  apollo: {
    // fetch all users
    participant: {
      query: MY_VACATIONS,
      variables() {
        return {
          user_id: localStorage.getItem("loggedInUserID"),
          confirmed: true,
        };
      },
    },
    invitation: {
      query: GET_INVITATIONS,
      fetchPolicy: "no-cache",
      variables() {
        return {
          user_id: localStorage.getItem("loggedInUserID"),
          accept_status: false,
        };
      },
    },
  },
  methods: {
    searchLocation(input) {
      const url = `https://places-dsn.algolia.net/1/places/query`;

      return new Promise((resolve) => {
        if (input.length < 3) {
          return resolve([]);
        }

        fetch(url, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            query: input,
            type: "city",
            language: "en",
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            let foundPlaces = [];
            data.hits.map((row) => {
              foundPlaces = foundPlaces.concat(row.locale_names);
            });
            resolve(foundPlaces);
          })
          .catch((error) => {
            let foundPlaces = [];
            foundPlaces.push(input);
            resolve(foundPlaces);
          });
      });
    },
    onGettingDestinationLocation: function(result) {
      this.destination = result;
      if (!this.destination) {
        this.showToast("Did you enter correct destination?", "error");
        return;
      } else if (this.destination.length < 3) {
        this.showToast(
          "That is so short, Hope your destination is atleast 3 characters!",
          "error"
        );
        return;
      }

      this.getDestinationLocation = false;
      this.getStartLocation = true;
    },
    onGettingSourceLocation: function(result) {
      this.source = result;
      if (!this.source) {
        this.showToast("Did you enter correct start location?", "error");
        return;
      } else if (this.source.length < 3) {
        this.showToast(
          "That is so short, Hope your start location is atleast 3 characters!",
          "error"
        );
        return;
      }
      this.getStartLocation = false;
      this.getStartDate = true;
    },
    onGettingStartDate: function(selectedDates, dateStr, instance) {
      if (this.dates.end && dateStr > this.dates.end) {
        this.showToast(
          "Looks like the end date is earlier than the start date!",
          "error"
        );
        return;
      }
      this.getStartDate = false;
      this.getEndDate = true;
    },
    onGettingEndDate: function(selectedDates, dateStr, instance) {
      if (this.dates.start && dateStr < this.dates.start) {
        this.showToast(
          "Looks like the start date is later than the end date!",
          "error"
        );
        return;
      }
      this.getEndDate = false;
      this.getTravelMode = true;
    },
    onGettingTravelMode: function() {
      this.getTravelMode = true;
      this.showSubmit = true;
    },
    onSubmit: function() {
      // add new vacation
      this.$apollo
        .mutate({
          mutation: ADD_VACATION,
          __typename: "vacation",
          variables: {
            dest_loc: this.destination && this.destination.trim(),
            end_date: this.dates.end,
            start_date: this.dates.start,
            start_loc: this.source && this.source.trim(),
            travel_mode: this.travelMode && this.travelMode.trim(),
            // TBD get this from auth service
            user_id: localStorage.getItem("loggedInUserID"),
          },
          update: (cache, { data: { insert_vacation_one } }) => {
            // Read the data from our cache for this query.
            try {
              const data = cache.readQuery({
                query: MY_VACATIONS,
                __typename: "vacation",
                variables: {
                  user_id: localStorage.getItem("loggedInUserID"),
                  confirmed: true,
                },
              });

              data.participant.splice(0, 0, { vacation: insert_vacation_one });

              cache.writeQuery({
                query: MY_VACATIONS,
                __typename: "vacation",
                data,
              });
            } catch (e) {
              console.error(e);
            }
          },
        })
        .then(({ data: { insert_vacation_one } }) => {
          this.$apollo.mutate({
            mutation: ADD_PARTICIPANT,
            variables: {
              confirmed: true,
              name: localStorage.getItem("loggedInUserName"),
              user_id: insert_vacation_one.user_id,
              vacation_id: insert_vacation_one.id,
            },
          });
          this.showToast("Done!", "success");
        })
        .catch((error) => {
          // Error
          console.error(error);
        });

      this.getTravelMode = false;
      this.getDestinationLocation = true;

      this.showModal = true;
      this.travelMode = "";
      this.source = "";
      this.destination = "";
      this.dates.start = "";
      this.dates.end = "";
    },
    showToast(message, type) {
      this.$toasted.show(message, {
        theme: "outline",
        position: type === "error" ? "top-center" : "top-right",
        duration: 5000,
        icon: {
          name:
            type === "error"
              ? "error_outline"
              : type === "success"
              ? "done_all"
              : "info_outline",
          after: true, // this will append the icon to the end of content
        },
      });
    },
  },
};
</script>
